/* GB metal-finish gate (Raven PDP, 2026-09-23).
   The "Metal Finish Barrel" GEAR chip ([data-gbmetal]) is only offered for Raven Brick units:
     visible <=> host variant == Raven Brick
             OR the active bundle-box bar holds a "Raven" slot whose colour is "Brick"
             OR the cart already has a Raven Brick line.
   Read-only on the cart: no /cart requests of its own (cart facts come from GBCart.addonState()
   and GBCart.subscribe). When the chip must hide while it is selected, it clicks the chip ONCE
   so the locked gb-gear-cart.js removes the line through its own queue (never retried).
   DOM nodes are re-queried on every evaluation (the chip row / bundle box may be re-rendered). */
(function (window, document) {
  'use strict';
  if (window.__gbmetal) return;
  window.__gbmetal = 1;

  var BRICK = '45217056129203';           // Raven Brick variant (other blasters also have a "Brick" colour)
  var brickInCart = false, cartSeen = false, cartBooted = false, booted = false;
  var timer = null, observer = null, observed = null;

  function norm(value) { return String(value == null ? '' : value).trim().toLowerCase(); }
  function metalCards() { return document.querySelectorAll('[data-gbgear] [data-gbit][data-gbmetal]'); }

  // Same host form the bundle box uses: form#product-form-<section id of [data-gbb]>.
  function hostInput() {
    var root = document.querySelector('[data-gbb]');
    var sid = root && root.getAttribute('data-section-id');
    var form = sid ? document.getElementById('product-form-' + sid) : null;
    if (!form) {
      var gear = document.querySelector('[data-gbgear]');
      var scope = (gear && gear.closest('.shopify-section')) || document;
      form = scope.querySelector('form[id^="product-form-"][data-type="add-to-cart-form"]') ||
        scope.querySelector('form[data-type="add-to-cart-form"]');
    }
    return form ? form.querySelector('input[name="id"], select[name="id"]') : null;
  }
  function hostIsBrick() {
    var input = hostInput();
    return !!(input && String(input.value) === BRICK);
  }
  // Missing bundle box -> no slots -> host-only fallback.
  function slotHasBrick() {
    var slots = document.querySelectorAll('[data-gbb] .gbb-bar.on .gbb-slot');
    for (var i = 0; i < slots.length; i++) {
      if (String(slots[i].getAttribute('data-vid')) === BRICK) return true;
      var name = slots[i].querySelector('.gbb-slot-name'), label = slots[i].querySelector('.gbb-chip-label');
      if (name && label && norm(name.textContent) === 'raven' && norm(label.textContent) === 'brick') return true;
    }
    return false;
  }
  function wanted() { return hostIsBrick() || slotHasBrick() || brickInCart; }

  function evaluate() {
    timer = null;
    watchBox();
    var show = wanted();
    var cards = metalCards();
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      if (card.hidden !== !show) card.hidden = !show;
      if (show) { card.__gbmetalDeselected = false; continue; }
      // Hidden while selected -> deselect exactly once per hidden episode (flag resets only when shown
      // again), and only once the cart facts are known so a Brick line in the cart is never missed.
      if (cartSeen && card.classList.contains('on') && !card.__gbmetalDeselected) {
        card.__gbmetalDeselected = true;
        card.click();
      }
    }
  }
  function schedule() {
    if (timer) window.clearTimeout(timer);
    timer = window.setTimeout(evaluate, 80);
  }

  function watchBox() {
    if (!window.MutationObserver) return;
    var root = document.querySelector('[data-gbb]');
    if (root === observed) return;
    if (observer) observer.disconnect();
    observed = root;
    if (!root) return;
    observer = observer || new MutationObserver(schedule);
    observer.observe(root, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['class', 'aria-checked'] });
  }

  function onCart(cart) {
    if (!cart) return;
    var items = cart.items || cart.lines || [], found = false;
    for (var i = 0; i < items.length; i++) {
      var line = items[i], vid = line.variant_id != null ? line.variant_id : line.variantId;
      if (String(vid) === BRICK && Number(line.quantity) > 0) { found = true; break; }
    }
    brickInCart = found;
    cartSeen = true;
    schedule();
  }
  function bootCart() {
    var api = window.GBCart;
    if (cartBooted || !api || typeof api.subscribe !== 'function') return;
    cartBooted = true;
    api.subscribe(onCart);
    try {
      var state = typeof api.addonState === 'function' ? api.addonState() : null;   // DOM snapshot, no request
      if (state && Array.isArray(state.lines)) onCart({ lines: state.lines });
    } catch (error) {}
  }

  function boot() {
    if (booted) return;
    booted = true;
    bootCart();
    document.addEventListener('gb:cart-ready', bootCart);
    document.addEventListener('change', schedule);
    window.addEventListener('pageshow', schedule);
    evaluate();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})(window, document);
